// File used only in shortcode [mb_registration_form]
import {registration} from "../modules/register";

// eslint-disable-next-line no-unused-vars
(function ($){
  registration();
})(jQuery);



// WEBPACK FOOTER //
// ./scripts/mulberrys/register-form-shortcode.js